import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { computed, makeAutoObservable } from 'mobx';
import {
    FilterLabelWrapper,
    FilterLabel,
    ActionButtonsWrapper,
    TrashIconWrapper,
    DragAndDropIconWrapper,
    MovableHandleWrapper,
} from './SportsFilters.style';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';

interface PropsTypes {
    slug: string;
    isDragged: boolean;
    sportState: CustomizedSportsState;
    dataTest?: string;
}

class State {
    constructor(
        private readonly slug: string,
        private readonly sportsState: CustomizedSportsState
    ) {
        makeAutoObservable(this);
    }

    setActiveFilter = (): void => {
        if (this.sportsState !== null) {
            this.sportsState.onActiveFilter(this.slug);
        }
    };

    handleRemoveFilter = (): void => {
        if (this.sportsState !== null) {
            this.sportsState.onRemoveFilter(this.slug);
        }
    };

    @computed public get isOpen(): boolean {
        if (this.sportsState !== null) {
            return this.sportsState.activeFilter === this.slug;
        }
        return false;
    }
}

export const SportsFilterItem = observer(({ slug, isDragged, sportState, dataTest }: PropsTypes) => {
    const [state] = useState(() => new State(slug, sportState));
    const { isOpen } = state;
    const filter = sportState.filtersMap.get(slug) ?? null;

    if (filter === null) {
        return null;
    }

    return (
        <FilterLabelWrapper
            isActive={isOpen}
            onClick={state.setActiveFilter}
        >
            <FilterLabel data-test={dataTest}>
                {filter.label} - {filter.competitionIds.length}
            </FilterLabel>
            <ActionButtonsWrapper>
                <MovableHandleWrapper data-movable-handle>
                    <DragAndDropIconWrapper isDragged={isDragged} />
                </MovableHandleWrapper>
                <TrashIconWrapper onClick={state.handleRemoveFilter} />
            </ActionButtonsWrapper>
        </FilterLabelWrapper>
    );
});
